import {
  SET_CURRENT_USER,
  REDIRECT,
  LOGIN,
  LOGOUT,
  ASYNC_START,
  ASYNC_END,
  STORE_TENANTS,
  SET_CURRENT_TENANT,
  PRODUCT_SAVED,
  PRODUCT_UPDATE_SUCCESS
} from "../actions/types";

const defaultState = {
  appName: "Purchase Engine",
  inProgress: false,
  currentUser: null,
  redirectTo: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        redirectTo: action.error ? null : "/"
      };
    case LOGOUT:
      return {
        ...state,
        redirectTo: "/login",
        currentUser: null,
        appLoaded: false
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        appLoaded: !action.error,
        currentUser: action.error ? null : action.currentUser
      };
    case ASYNC_START:
      return { ...state, inProgress: true };
    case ASYNC_END:
      return { ...state, inProgress: false };
    case STORE_TENANTS:
      const { tenants } = action;
      return { ...state, tenants };
    case SET_CURRENT_TENANT:
      const { currentTenant } = action;
      return {
        ...state,
        currentTenant
      };
    case PRODUCT_SAVED:
      return { ...state, redirectTo: "/products" };
    case PRODUCT_UPDATE_SUCCESS:
      return { ...state, redirectTo: "/products" };
    case REDIRECT:
      return { ...state, redirectTo: null };
    default:
      return state;
  }
};
